import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
} from '@redteclab/api/clients/bully'

export const userSubOrderAccessorIsSubOrderReturnable = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
): boolean => {
  const { orderDocuments } = subOrder

  if (!orderDocuments) {
    return false
  }

  const documentPositions = orderDocuments.flatMap(
    (item) => item.documentPositions,
  )

  return documentPositions.some((docPosition) => docPosition?.isReturnable)
}
